import { Box, lighten, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useAppStore } from "@/global/store";
import React from "react";
import { SeatMap2d } from "./SeatMap2d";
import { seatMapState, selectViewId3d } from "@/global/store/data/seatMap";
import { SeatMapCarousel } from "../../common/SeatMapCarousel/SeatMapCarousel";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useSelectActiveEvent } from "../PurchaseSeats/ChooseSeats/useSelectActiveEvent";
import { calcDynamicSeatMapId, type SeatMap } from "./utils.seatMap";
import type { EventType } from "@/global/store/data/types";

interface InteractiveSeatMapProps {
  event?: EventType | null;
}

export function InteractiveSeatMap({ event }: InteractiveSeatMapProps = {}) {
  const dispatch = useDispatch();
  const teamConfig = useTeamConfig();
  const { activeEvent } = useSelectActiveEvent();
  const viewId3dSelected = useAppStore(selectViewId3d);
  const [mapId, setSeatMapId] = React.useState<SeatMap | null>(null);

  const purchaseSeatsLanguageDisclaimer =
    teamConfig?.languages?.purchaseSeats?.purchaseSeatsLanguageDisclaimer ||
    null;

  React.useEffect(() => {
    return () => {
      dispatch(seatMapState.actions.set({ viewId3d: "" }));
    };
  }, []);

  React.useEffect(() => {
    const seatMap = calcDynamicSeatMapId(teamConfig, activeEvent);
    setSeatMapId(seatMap);
  }, [activeEvent]);

  return (
    <Box>
      {!viewId3dSelected && mapId ? <SeatMap2d mapId={mapId} /> : null}
      {viewId3dSelected ? <SeatMapCarousel event={event} /> : null}
      {purchaseSeatsLanguageDisclaimer ? (
        <Box
          p={1}
          mb={2}
          mt={2}
          borderRadius={1}
          sx={{
            bgcolor: lighten(teamConfig?.colors?.primary, 0.8),
          }}
        >
          <Typography variant="caption">
            {purchaseSeatsLanguageDisclaimer}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}
